<div class="overview">
  <section class="info-grid">
    <!-- Contact Block -->
    <div class="data-block">
      <h3>{{ "CARRIERDB.COMPANY_CONTACT" | translate : locale.language }}</h3>
      <div class="block-container">
        <div class="block-item">
          <div>
            <b> {{ "CARRIERDB.NEW_CARRIER_FORM.COMPANY_NAME" | translate : locale.language  }}: </b>
          </div>
          <div>{{ supplierContactData.companyName }}</div>
        </div>
        <div class="block-item">
          <div>
            <b> {{ "CARRIERDB.NEW_CARRIER_FORM.REP_NAME"| translate : locale.language  }}: </b>
          </div>
          <div>
            {{ supplierContactData.representativeFirstName }}
            {{ supplierContactData.representativeLastName }}
          </div>
        </div>
        <div class="block-item">
          <div>
            <b> {{ "CARRIERDB.NEW_CARRIER_FORM.EMAIL" | translate : locale.language }}: </b >
          </div>
          <div>{{ supplierContactData.emailAddress }}</div>
        </div>
        <div class="block-item">
          <div>
            <b> {{ "CARRIERDB.NEW_CARRIER_FORM.WEBSITE" | translate : locale.language }}: </b >
          </div>
          <div>{{ supplierContactData.website }}</div>
        </div>
        <div class="block-item">
          <div>
            <b> {{ "CARRIERDB.NEW_CARRIER_FORM.TELEPHONE" | translate : locale.language  }}: </b >
          </div>
          <div>{{ supplierContactData.phoneNumber }}</div>
        </div>
        <div class="block-item">
          <div>
            <b> {{"CARRIERDB.NEW_CARRIER_FORM.WEBSITE"| translate : locale.language }}:</b >
          </div>
          <div>{{ supplierContactData.mobileNumber }}</div>
        </div>
      </div>
    </div>
    <!-- Address Block -->
    <div class="data-block">
      <h3>
        {{ "CARRIERDB.NEW_CARRIER_FORM.ADDRESS" | translate : locale.language }}
      </h3>
      <div class="block-grid">
        <div class="block-item">
          <div>
            <b>{{ "CARRIERDB.NEW_CARRIER_FORM.STREET"  | translate : locale.language }}:</b>
          </div>
          <div>{{ supplierContactData.street }}</div>
        </div>
        <div class="block-item">
          <div>
            <b>  {{"CARRIERDB.NEW_CARRIER_FORM.POSTAL_CODE"  | translate : locale.language}}:</b >
          </div>
          <div>
            {{ supplierContactData.postalCode }}
          </div>
        </div>
        <div class="block-item">
          <div>
            <b> {{"CARRIERDB.NEW_CARRIER_FORM.CITY" | translate : locale.language  }}:</b>
          </div>
          <div>{{ supplierContactData.city }}</div>
        </div>
        <div class="block-item">
          <div>
            <b>{{  "CARRIERDB.NEW_CARRIER_FORM.COUNTRY" | translate : locale.language }}:</b>
          </div>
          <div>{{ supplierContactData.country }}</div>
        </div>
      </div>
    </div>
    <!-- Green Factor Block -->
    <div class="data-block">
      <h3>
        Green Factor {{ "CARRIERDB.INFORMATION" | translate : locale.language }}
      </h3>
      <div class="block-grid">
        <div class="block-item">
          <div>
            <b> {{"CARRIERDB.NEW_CARRIER_FORM.CO2_SCORE" | translate : locale.language}}:</b>
          </div>
          <div>{{ supplierContactData.co2Score }}</div>
        </div>
        <div class="block-item">
          <div>
            <b> {{"CARRIERDB.NEW_CARRIER_FORM.TOTAL_CO2_EMISSION"| translate : locale.language}}:</b>
          </div>
          <div>
            {{ supplierContactData.co2EmissionTotal }}
          </div>
        </div>
        <div class="block-item">
          <div>
            <b> {{"CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM"  | translate : locale.language}}:</b >
          </div>
          <div>{{ supplierContactData.scorePlatform }}</div>
        </div>
        <div class="block-item">
          <div>
            <b>{{ "CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM" | translate : locale.language }} Link:</b>
          </div>
          <div>{{ supplierContactData.scorePlatformLink }}</div>
        </div>
      </div>
    </div>
  </section>

  <h3>{{ "CARRIERDB.COMPANY_DETAILS" | translate : locale.language }}</h3>
  <p-accordion
    [multiple]="true"
    [(activeIndex)]="activeAccordionTabs"
    iconPos="start"
    class="mt-2 g-2"
  >
    <!-- Selected Services Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.services"
      title="{{ 'CARRIERDB.NEW_CARRIER_FORM.SERVICES' | translate : locale.language}}"
    />
    <!-- Selected Industries Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.industries"
      title="{{ 'CARRIERDB.NEW_CARRIER_FORM.INDUSTRIES' | translate : locale.language}}"
    />
    <!-- Selected Transport Segments: Air Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.segmentsAir"
      title="{{ 'CARRIERDB.SEGMENTS' | translate : locale.language }}: {{'CARRIERDB.SEGMENT.AIR' | translate : locale.language}}"
    />
    <!-- Selected Transport Segments: Rail Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.segmentsRail"
      title="{{ 'CARRIERDB.SEGMENTS' | translate : locale.language }}: {{'CARRIERDB.SEGMENT.RAIL' | translate : locale.language}}"
    />
    <!-- Selected Transport Segments: Road Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.segmentsRoad"
      title="{{ 'CARRIERDB.SEGMENTS' | translate : locale.language }}: {{'CARRIERDB.SEGMENT.ROAD' | translate : locale.language}}"
    />
    <!-- Selected Transport Segments: Sea Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="supplierSelectionData.segmentsSea"
      title="{{ 'CARRIERDB.SEGMENTS' | translate : locale.language }}: {{'CARRIERDB.SEGMENT.SEA' | translate : locale.language}}"
    />
    <!-- Selected Region: Africa Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsAfrica)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.AFRICA' | translate : locale.language}}"
    />
    <!-- Selected Region: Asia Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsAsia)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.ASIA' | translate : locale.language}}"
    />
    <!-- Selected Region: Australia Pacific Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsAustraliaPacific)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.AUSTRALIA_PACIFIC' | translate : locale.language}}"
    />
    <!-- Selected Region: Europe Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsEurope)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.EUROPE' | translate : locale.language}}"
    />
    <!-- Selected North America Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsNorthAmerica)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.NORTH_AMERICA' | translate : locale.language}}"
    />
    <!-- Selected South America Tab -->
    <supplierDB-registration-overview-selection-tab 
      [selectionData]="getRegionNames(supplierSelectionData.regionsSouthAmerica)"
      title="{{ 'CARRIERDB.LOCATIONS' | translate : locale.language }}: {{'CARRIERDB.REGION.SOUTH_AMERICA' | translate : locale.language}}"
    />
  </p-accordion>
</div>
